// extracted by mini-css-extract-plugin
module.exports = {"container":"_2hcsjp","size-xs":"_3WIxDO","size-s":"_1w1CHL","size-m":"_3Qbi3n","size-l":"_3wKEAE","loader":"_2MFkYI"};